/**
 * Unified display name for a captured price, used everywhere a price/product name is shown
 * (auditor console, levantamiento general, price-by-SKU graph, drill-downs, exports).
 *
 * Format: "[segment] [name] - [grams]g", e.g. "Arroz La Pampa - 500g".
 * Missing parts are dropped gracefully:
 *   - no segment  -> "La Pampa - 500g"
 *   - no grams    -> "Arroz La Pampa"
 *   - no name     -> "—"
 *
 * Accepts objects using either `productName` (read model) or `name` (audit product) for the name.
 */
export function formatPriceName(item = {}) {
    const segment = item.segment != null ? String(item.segment).trim() : '';
    const name = String(item.productName ?? item.name ?? '').trim();
    // Only show a positive weight; 0 / null / '' means "unspecified".
    const grams = Number(item.grams) > 0 ? item.grams : null;

    const head = [segment, name].filter(Boolean).join(' ');
    if (!head) return '—';
    return grams != null ? `${head} - ${grams}g` : head;
}

export default formatPriceName;
